var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Checkbox } from '../checkbox';
import { FormGroup } from '../form/form-group';
import { FormField } from '../form/form-field';
export var CheckboxField = React.forwardRef(function (props, ref) {
    var error = props.error, options = props.options, required = props.required, row = props.row, value = props.value, name = props.name, label = props.label, onChange = props.onChange, onBlur = props.onBlur, helperText = props.helperText, _a = props.CheckboxProps, CheckboxProps = _a === void 0 ? {} : _a, _b = props.FormGroupProps, FormGroupProps = _b === void 0 ? {} : _b, rootProps = __rest(props, ["error", "options", "required", "row", "value", "name", "label", "onChange", "onBlur", "helperText", "CheckboxProps", "FormGroupProps"]);
    var optionsList = React.useMemo(function () {
        return options.filter(Boolean);
    }, [options]);
    return (React.createElement(FormField, __assign({ ref: ref, label: label, error: error, helperText: helperText, required: required }, rootProps),
        React.createElement(FormGroup, __assign({ row: row }, FormGroupProps, { onBlur: onBlur }), optionsList.map(function (option, i) {
            var getCheckedValue = function () {
                if (Array.isArray(value)) {
                    return value.includes(option.value);
                }
                return value && value[option.value];
            };
            return (React.createElement(Checkbox, __assign({ key: i, name: name, onChange: onChange, checked: getCheckedValue() }, CheckboxProps, option), option.label));
        }))));
});
